interface HeaderNavLinkProps {
    active: boolean;
    onClick: () => void;
    children: React.ReactNode;
  }
  
  const HeaderNavLink: React.FC<HeaderNavLinkProps> = ({ children, active, onClick }) => {
    const linkClassName = active ? 'activeLink' : 'ecoHeader';
  
    return (
      <div  className={linkClassName} onClick={onClick}>
        {children}
      </div>
    );
  };

  export default HeaderNavLink;